import { TokenInfo, TokenListProvider } from "@solana/spl-token-registry";

export class TokenMapService {
  private static tokenMap: Map<string, TokenInfo> | null = null;
  private static isLoading = false;
  private static loadingPromise: Promise<Map<string, TokenInfo>> | null = null;

  static async getTokenMap(): Promise<Map<string, TokenInfo>> {
    if (this.tokenMap) {
      return this.tokenMap;
    }

    if (this.isLoading && this.loadingPromise) {
      return this.loadingPromise;
    }

    this.isLoading = true;
    this.loadingPromise = this.loadTokens();

    try {
      this.tokenMap = await this.loadingPromise;
      return this.tokenMap;
    } finally {
      this.isLoading = false;
      this.loadingPromise = null;
    }
  }

  private static async loadTokens(): Promise<Map<string, TokenInfo>> {
    const tokenListProvider = new TokenListProvider();
    const tokens = await tokenListProvider.resolve();
    const tokenList = tokens.filterByClusterSlug("mainnet-beta").getList();

    return tokenList.reduce((map, item) => {
      map.set(item.address, item);
      return map;
    }, new Map<string, TokenInfo>());
  }

  static clearCache(): void {
    this.tokenMap = null;
    this.isLoading = false;
    this.loadingPromise = null;
  }
}
